import { render } from "./request-info-card.vue?vue&type=template&id=60fa671d&scoped=true"
import script from "./request-info-card.vue?vue&type=script&lang=js"
export * from "./request-info-card.vue?vue&type=script&lang=js"

import "./request-info-card.vue?vue&type=style&index=0&id=60fa671d&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fa671d"]])

export default __exports__